import { render } from "./studentView.vue?vue&type=template&id=7e3128ff"
import script from "./studentView.vue?vue&type=script&lang=js"
export * from "./studentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__